import { OVERLAY_TOGGLE, OVERLAY_HIDE, OVERLAY_SHOW } from './actionTypes'

export const overlayToggle = () => ({
  type: OVERLAY_TOGGLE
})

export const showOverlay = () => ({
  type: OVERLAY_SHOW
})

export const hideOverlay = () => ({
  type: OVERLAY_HIDE
})
